import React, { useState } from "react";
import "./Contact.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const phoneNumber = "919443777668"; // 👈 change to your real WhatsApp number (with country code, no '+')

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `Hello, I am ${formData.name}. My email is ${formData.email}. ${formData.message}`;
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    
    window.open(whatsappURL, "_blank");

    setFormData({ name: "", email: "", message: "" });
    alert("✅ Message ready to send on WhatsApp!");
  };

  return (
    <section className="contact-section" id="contact">
      <h2 className="contact-heading">Contact Us</h2>

      <div className="contact-container">
        {/* Left Side */}
        <div className="contact-left">
          <h3>Let's Paint Your Dream Space</h3>
          <p>
            Get in touch with SaiSree Paints & Hardware for all your interior, exterior, 
            and decorative paint needs. We bring color, quality, and beauty to every wall.
          </p>

          <div className="contact-info">
            <p><FaPhoneAlt /> +91 9443777668</p>
            <p><FaEnvelope /> saisreeenterprises2017@gmail.com</p>
            <p><FaMapMarkerAlt /> Sivapriya Nagar,Senthangudy,Mayiladuthurai</p>
          </div>
        </div>

        {/* Right Side */}
        <div className="contact-right">
          <form onSubmit={handleSubmit} className="contact-form">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>

      {/* Google Map */}
      <div className="contact-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d31319.368574519995!2d79.6686784!3d11.1192562!3m2!1i1024!2i768!4f13.1!2m1!1ssaisree%20hardwares%20in%20mayiladuthurai!5e0!3m2!1sen!2sin!4v1762850974519!5m2!1sen!2sin"
          width="600"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="SaiSree Hardwares Location"
        ></iframe>
      </div>
    </section>
  );
};

export default Contact;
